import React, { useState, useEffect } from 'react';
import '../styles/theme-header.css';

interface ThemeHeaderProps {
  className?: string;
  onSiteLogout?: () => void;
}

const ThemeHeader: React.FC<ThemeHeaderProps> = ({ className = '', onSiteLogout }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const headerRef = React.useRef<HTMLElement>(null);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    console.log('Mobile menu state:', !mobileMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Enhanced header appearance after scrolling 50px
      if (currentScrollY > 50) {
        setIsSticky(true);
        
        // Auto-hide logic: hide when scrolling down, show when scrolling up
        if (currentScrollY > lastScrollY && currentScrollY > 200) {
          setIsHidden(true);
        } else {
          setIsHidden(false);
        }
      } else {
        setIsSticky(false);
        setIsHidden(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  // Generate dynamic classes
  const headerClasses = [
    'wp-site-header',
    className,
    isSticky ? 'wp-scrolled' : '',
    isHidden ? 'wp-hidden' : '',
    mobileMenuOpen ? 'wp-menu-open' : ''
  ].filter(Boolean).join(' ');

  return (
    <>
      <header id="wp-masthead" className={headerClasses} role="banner" ref={headerRef}>
        <div className="wp-container">
          <div className="wp-main-header">
            <div className="wp-left-section">
            <div className="wp-site-branding">
              <div className="wp-site-logo">
                <a href="#" onClick={() => window.location.reload()} rel="home">
                  <img src="/images/logounicoheader.png" alt="UNICO" className="wp-logo-image" />
                </a>
                <p className="wp-site-tagline">Różnicę stanowi jakość</p>
              </div>
            </div>            {/* Quick Contact Button */}
            <div className="wp-quick-contact">
              <a href="tel:+48748324690" className="wp-contact-btn">
                <span className="wp-contact-text">SZYBKI KONTAKT</span>
                <span className="wp-contact-number">+48 74 832 46 90</span>
              </a>
            </div>
          </div>
          
          {/* Desktop Navigation Link */}
          <div className="wp-desktop-nav">
            <a href="https://unico-kominki.pl" className="wp-desktop-link" target="_blank" rel="noopener noreferrer">OTWÓRZ STRONĘ WWW.UNICO-KOMINKI.PL W NOWEJ KARCIE PRZEGLĄDARKI</a>
            {onSiteLogout && (
              <button 
                onClick={onSiteLogout}
                className="wp-logout-btn"
              >
                WYLOGUJ
              </button>
            )}
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className="wp-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={mobileMenuOpen}
          >
            <div className="wp-menu-icon">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
        </div>
        
        {/* Mobile Menu Backdrop */}
        <div className="wp-mobile-menu-backdrop" onClick={toggleMobileMenu}></div>
        
        {/* Mobile Navigation */}
        <nav className="wp-mobile-navigation" role="navigation" aria-label="Mobile Navigation">
          <div className="wp-mobile-nav-container">
            <ul className="wp-mobile-menu">
              <li><a href="https://unico-kominki.pl" target="_blank" rel="noopener noreferrer">OTWÓRZ STRONĘ WWW.UNICO-KOMINKI.PL W NOWEJ KARCIE PRZEGLĄDARKI</a></li>
              <li>
                <a 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    const event = new CustomEvent('showInstructionModal')
                    window.dispatchEvent(event)
                    toggleMobileMenu()
                  }}
                  style={{
                    paddingTop: '10px',
                    display: 'block'
                  }}
                >
                  JAK KORZYSTAĆ?
                </a>
              </li>
              {onSiteLogout && (
                <li>
                  <button 
                    onClick={() => {
                      onSiteLogout();
                      toggleMobileMenu();
                    }}
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      background: 'transparent',
                      border: 'none',
                      color: '#D2B48C',
                      padding: '15px 20px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600',
                      display: 'block',
                      textTransform: 'uppercase',
                      letterSpacing: '1px'
                    }}
                  >
                    WYLOGUJ
                  </button>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </div>
      </header>
    </>
  );
};

export default ThemeHeader;